export function isMobile11(value) {
  return /^1\d{10}$/.test(String(value || "").trim());
}

export function isEmail(value) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || "").trim());
}

